import * as React from 'react'
import styled from 'styled-components'

import { TextBody } from '@ally/metronome-ui'
import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'
import { StyledTextBody } from '../Shared'

const StyledPhoneNumber = styled(TextBody)`
  white-space: nowrap;
`

const AddAutoAccountGenericFailureContent: React.FC = () => {
  return (
    <>
      <LoginHeading title="We couldn’t add your account." />

      <StyledTextBody size="sm" tag="p">
        To add your Auto account and continue to Snapshot, give us a call at{' '}
        <StyledPhoneNumber size="sm" tag="b" weight="bold">
          1-888-925-2559
        </StyledPhoneNumber>
        .
      </StyledTextBody>
    </>
  )
}

export const AddAutoAccountGenericFailure: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'AddAutoAccountGenericFailure') {
    return null
  }

  return <AddAutoAccountGenericFailureContent />
}
